class ServiceError {
  title: string;
  body: string;
  data?: any;

  constructor(title: string, body: string, data?: any) {
    this.title = title;
    this.body = body;
    this.data = data;
  }

  public toString() {
    return this.title + ": " + this.body;
  }
}

export default ServiceError;
